import $ from "jquery";
import Splide from '@splidejs/splide';

export default class SponsorsSliderManager {

    sliderElement = document.querySelector('[data-id="featured-sponsors-slider"]');

    constructor() {
        if(this.sliderElement) {
            new Splide('[data-id="featured-sponsors-slider"]', {
                type: 'loop',
                rewind: true,
                perPage: 5,
                autoplay: true,
                cover: true,
                classes: {
                    pagination: 'splide__pagination',
                    page: 'splide__pagination__page'
                },
                breakpoints: {
                    400: {
                        perPage: 1,
                    },
                    768: {
                        perPage: 2,
                    },
                    992: {
                        perPage: 3,
                    },
                    1200: {
                        perPage: 4
                    }
                }
            }).mount();
        }
    }
}